import { render, staticRenderFns } from "./producttype.vue?vue&type=template&id=da73772e&"
import script from "./producttype.vue?vue&type=script&lang=ts&"
export * from "./producttype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports